"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var tslib_1 = require("tslib");
var menu_item_style_1 = require("../../../components/menu/menu.item.style");
var theme_1 = require("../../../components/theme");
var theme_util_1 = require("../../../components/theme.util");
exports.CSS = {
    container: 'c-FormEditFieldInfo',
    section: {
        container: 'c-FormEditFieldInfo__section',
        final: 'c-FormEditFieldInfo__section--final'
    },
    move: 'c-FormEditFieldInfo__move',
    title: 'c-FormEditFieldInfo__title',
    type: 'c-FormEditFieldInfo__type',
    menu: 'c-FormEditFieldInfo__menu',
    input: {
        container: 'c-FormEditFieldInfo__input',
        title: 'c-FormEditFieldInfo__inputTitle',
        value: 'c-FormEditFieldInfo__inputValue'
    },
    option: 'c-FormEditFieldInfo__option',
    optionButton: 'c-FormEditFieldInfo__optionButton',
    isOptionActive: 'c-FormEditFieldInfo__option--is-active'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = tslib_1.__assign(tslib_1.__assign({ display: 'flex', 'flex-direction': 'column' }, theme_util_1.IkeCssUtil.padding(1, 8)), { position: 'relative' }),
    _a[exports.CSS.section.container] = {
        display: 'flex',
        'align-items': 'center'
    },
    _a[exports.CSS.section.final] = {
        'margin-bottom': theme_1.DefaultTheme.space(8)
    },
    _a[exports.CSS.menu] = (_b = {},
        _b["& .".concat(menu_item_style_1.CSS.item)] = {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6)
        },
        _b),
    _a[exports.CSS.title] = theme_util_1.IkeCssUtil.Flex.centerVertical,
    _a[exports.CSS.type] = {
        'align-items': 'center',
        '& > i': {
            margin: "0 ".concat(theme_1.DefaultTheme.space(1))
        }
    },
    _a[exports.CSS.option] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    _a[exports.CSS.input.container] = {
        'margin-right': theme_1.DefaultTheme.space(4),
        height: theme_1.DefaultTheme.space(8),
        display: 'flex',
        cursor: 'default'
    },
    _a[exports.CSS.option] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    _a[exports.CSS.input.value] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { height: theme_1.DefaultTheme.space(8) }),
    _a[exports.CSS.input.title] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { 'margin-right': theme_1.DefaultTheme.space(2), 'font-weight': 'bold', overflow: 'hidden' }),
    _a[exports.CSS.move] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.absolute(2, 1)), theme_util_1.IkeCssUtil.Flex.column), { width: theme_1.DefaultTheme.space(8) }),
    _a);
//# sourceMappingURL=form.info.panel.style.js.map